import React, { useEffect, useState } from "react";
import { SafeAreaView, StyleSheet, useWindowDimensions, Platform, View } from "react-native";
import { loadSurvey, loadEverySurvey } from "../../../services/SurveyService";
import Modal from "react-native-modal";
import CustomButton from '../../CustomButton/CustomButton';
import CustomDropDown from "../../CustomDropDown/CustomDropdown";
import CustomLabel from "../../CustomLabel/CustomLabel";
import { useTheme } from '@react-navigation/native';
import { useTranslation } from 'react-i18next';
import { useAuthContext } from '../../../hooks/useAuthContext';

const PopUp = ({ index, sectionIndex, handleAdd, setClickListener, isSection = 0 }) => {

    const { colors } = useTheme()
    const styles = makeStyles(colors);
    const { t } = useTranslation();
    const { user, clientApi } = useAuthContext();
    const { width, height } = useWindowDimensions();
    const [PopUpvisible, setPopUpVisible] = useState(false)
    const [SurveyView, setSurveyView] = useState('');
    const [QuestionView, setQuestionView] = useState('');
    const [surveysList, setSurveysList] = useState([]);
    const [list, setList] = useState([]);
    const [selected, setselected] = useState('');
    const [boxColor, setBoxColor] = useState(colors.background);

    useEffect(() => {
        loadEverySurvey(clientApi).then(Survey => {
            var tempSurvey = []
            Survey.map((surveyItr) => {
                tempSurvey.push({ label: surveyItr.survey_name, value: surveyItr.id })
            })
            // console.log(tempSurvey)
            setSurveysList(tempSurvey)
        }).catch(error => {
            console.log(error)
        });
    }, []);

    useEffect(
        () => {
            // * No need to do anything here
        },
        [width, height]
    );
    const showPopUp = (e) => {
        setPopUpVisible(!PopUpvisible)
    }

    const handleSurveyViewChange = (e) => {
        var tempArr = []
        if (e !== '') {
            setList([])
            setselected('')
            if (isSection === 0) {
                loadSurvey(e, user.token).then(survey => {
                    survey.ss.map((section) => {
                        section.section_questions.map(question => {
                            tempArr.push({ label: question.question_name, value: question.id })
                        })
                        // console.log(e)
                        // console.log(tempArr)
                        setList(tempArr)
                        setSurveyView(e)
                    })
                }).catch(error => {
                    console.log(error)
                });
            } else {
                loadSurvey(e, user.token).then(survey => {
                    survey.ss.map((section) => {
                        // console.log(section)
                        tempArr.push({ label: section.section_name, value: section.id })
                    })
                    setList(tempArr)
                    setSurveyView(e)
                }).catch(error => {
                    console.log(error)
                });
            }
        }
    }

    const handleQuestionViewChange = (e) => {
        setQuestionView(e)
        setselected(e)
    }

    const selectAddQuestion = () => {
        console.log("selected is")
        console.log(selected)
        if (selected !== '') {
            if (isSection === 1) {
                setClickListener(sectionIndex, selected)
                console.log("all good")
            } else {
                setClickListener(index, sectionIndex, selected)
            }
            setBoxColor(theme.palette.primary.dark)
        } else {
            setBoxColor('red')
        }
    }

    return (
        <SafeAreaView
            style={styles.main}>
            <View
                style={styles.rowBtn}>
                <CustomButton
                    text={Platform.OS === 'web' && width > 1300 ? (isSection === 1 ? t('common:addSection') : t('common:addQuestion')) : ''}
                    onPress={handleAdd}
                    iconName='add-outline'
                    show='SURVEY'
                    type='SURVEY'
                    isGradient={true}
                    textTop='0'
                    isGradient={true}
                    sz={25}
                />
                <CustomButton
                    text={Platform.OS === 'web' && width > 1300 ? (t('common:importSurvey')) : ''}
                    onPress={() => { showPopUp() }}
                    iconName='download-outline'
                    show='SURVEY'
                    type='SURVEY'
                    textTop='0'
                    sz={25}
                />
            </View>

            <Modal
                isVisible={PopUpvisible}
                deviceWidth={width}
                deviceHeight={height}
                hasBackdrop={true}
                backdropColor={colors.background_approved}
                backdropOpacity={0.9}
                onBackdropPress={() => { showPopUp() }}
                onRequestClose={() => { showPopUp() }}
            >
                <SafeAreaView
                    style={styles.main}>
                    <CustomLabel
                        value={`Import a ${isSection === 0 ? "Question" : "Section"} from a Survey`}
                        type='MINORTITLE'
                    />

                    <SafeAreaView
                        style={styles.dropDownView}>
                        <CustomDropDown
                            defValue={SurveyView}
                            options={surveysList}
                            value={SurveyView}
                            setValue={(e) => handleSurveyViewChange(e)}
                            type='FULL'
                        />
                    </SafeAreaView>
                    <SafeAreaView
                        style={styles.dropDownView}>
                        <CustomDropDown
                            defValue="SurveyResults"
                            options={list}
                            value={QuestionView}
                            setValue={(e) => handleQuestionViewChange(e)}
                            type='FULL'
                        />
                    </SafeAreaView>
                    <SafeAreaView
                        style={styles.buttons}>
                        <SafeAreaView
                            style={styles.row}>
                            <CustomButton
                                onPress={() => { showPopUp() }}
                                iconName='close-outline'
                                show='HOME_BELL'
                                type='HOME_BELL'
                                textTop='0'
                                sz={30}
                            />
                            <CustomButton
                                onPress={() => { selectAddQuestion() }}
                                iconName='checkmark-outline'
                                show='HOME_BELL'
                                type='HOME_BELL'
                                textTop='0'
                                sz={30}
                            />
                        </SafeAreaView>
                    </SafeAreaView>
                </SafeAreaView>
            </Modal>
        </SafeAreaView>
    )

}

const makeStyles = (colors) => StyleSheet.create({
    main: {

        justifyContent: 'center',
    },
    dropDownView: {
        margin: 20,
    },
    buttons: {
        alignSelf: 'flex-end',

    },
    row: {
        alignItems: 'center',
        flexDirection: 'row',
    },
    rowBtn: {
        flexDirection: 'row',
        justifyContent: 'flex-start',
    },

});
export default PopUp;


